import React, { Component } from 'react';

class Errorpage extends Component {
    render() {
        return (
            <div className="wrap">
                <section className="py-24 px-4 sm:px-6">
                    <div className="max-w-lg mx-auto text-center">
                        <i className="fa fa-times-circle" style={{ fontSize: 80, color: '#ef4444' }}></i>
                        <h1 className="mt-6 text-3xl sm:text-4xl font-bold text-ink-primary">Oops… an error occurred</h1>
                        <div className="mx-auto mt-3 h-1 w-16 bg-accent rounded-full"></div>
                        <p className="mt-6 text-ink-secondary leading-relaxed">
                            Your network firewall or browser settings may be blocking some requests. Unable to send your message right now — try again on another network.
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}
export default Errorpage;
